/* Chamax sales popup — replaces the Sales Pop app.
   Round 9: real-product purchase popups. Round 10 (popup v2, Shaun's spec):
   a new popup every ~15 seconds for the whole visit (no session cap), three
   entry types randomized like the old Sales Pop — "Purchased <product>",
   "Added to Cart <product>" (roughly equal share) and a "visitors today"
   card (~1 in 3). Entries are composed from REAL current break products
   (title, image, URL, in-stock team names rendered server-side by
   snippets/chamax-sales-pop.liquid); buyer names, cities, times and the
   visitor count are illustrative, in the same format Sales Pop showed.
   Visible ~5s per popup (5 on / 10 off), first popup ~8s after load.
   Close (x) ends popups for the session and sets a 7-day opt-out
   (localStorage); timers pause while the tab is hidden and while the
   visitor hovers the card; mobile is OFF unless the snippet's
   chamax_pop_mobile flag is enabled (window.ChamaxPopConfig.mobile).
   Test hook: append ?chamaxpop=1 to any URL — popups start immediately and
   cycle purchase -> added-to-cart -> visitor in that order (then random),
   bypassing the opt-out, so all three types can be verified quickly.
   Reset hook (round 10.1): append ?chamaxpop=reset — clears this popup's
   localStorage/sessionStorage keys, then lets the NATURAL flow run (first
   popup ~8s), for re-verifying natural appearance in a browser profile
   that previously clicked the close button (7-day opt-out).
   Click handling (round 10.1): hit-testing of the shipped card is clean
   (elementFromPoint at the card centre lands on a child of the anchor and
   a trusted click navigates), but navigation is not left to the anchor's
   default alone: a capture-phase click handler on the popup root forces
   same-tab navigation for any click inside a purchase / added-to-cart
   card (except the close button), so a click delivered to a child element
   — or one another script tried to cancel — still reaches the product. */
(function () {
  var cfg = window.ChamaxPopConfig || {};
  var testMode = /[?&]chamaxpop=1(?:&|$)/.test(window.location.search);
  var resetMode = /[?&]chamaxpop=reset(?:&|$)/.test(window.location.search);

  if (!cfg.mobile && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
    return; /* mobile off (Shaun's preference; flip the Liquid flag to enable) */
  }

  var OPTOUT_KEY = 'chamax-pop-off';
  var OPTOUT_MS = 7 * 24 * 60 * 60 * 1000;
  var FIRST_DELAY = 8000;
  var VISIBLE_MS = 5000;
  var GAP_MS = 10000; /* 5s visible + 10s gap = a popup every ~15s */
  var TEST_GAP_MS = 2000;

  if (resetMode) {
    try {
      localStorage.removeItem(OPTOUT_KEY);
      for (var li = localStorage.length - 1; li >= 0; li--) {
        var lk = localStorage.key(li);
        if (lk && lk.indexOf('chamax-pop') === 0) { localStorage.removeItem(lk); }
      }
    } catch (e) {}
    try {
      for (var si = sessionStorage.length - 1; si >= 0; si--) {
        var sk = sessionStorage.key(si);
        if (sk && sk.indexOf('chamax-pop') === 0) { sessionStorage.removeItem(sk); }
      }
    } catch (e) {}
  }

  try {
    var offAt = parseInt(localStorage.getItem(OPTOUT_KEY) || '0', 10);
    if (!testMode && offAt && (Date.now() - offAt) < OPTOUT_MS) { return; }
  } catch (e) {}

  var root = document.getElementById('ChamaxPop');
  var poolEl = document.getElementById('ChamaxPopPool');
  if (!root || !poolEl) { return; }
  var pool = null;
  try { pool = JSON.parse(poolEl.textContent); } catch (e) { return; }
  if (!pool || !pool.length) { return; }

  var NAMES = ['Olle', 'Astrid', 'Lars', 'Emma', 'Liam', 'Noah', 'Mateo', 'Rafael',
    'Priya', 'Arjun', 'Ananya', 'James', 'Michael', 'Sarah', 'Jessica', 'David',
    'Ashley', 'Chris', 'Amanda', 'Justin', 'Marie', 'Chloe', 'Pierre', 'Hans',
    'Yuki', 'Sofia', 'Lucas', 'Mia', 'Ethan', 'Olivia', 'Ben', 'Tom', 'Nick', 'Ryan'];
  var CITIES = ['Skanor, Sweden', 'Stockholm, Sweden', 'Rio de Janeiro, Brazil',
    'Sao Paulo, Brazil', 'Chennai, India', 'Mumbai, India', 'Toronto, Canada',
    'Montreal, Canada', 'Vancouver, Canada', 'Calgary, Canada',
    'New York, United States', 'Chicago, United States', 'Austin, United States',
    'Denver, United States', 'Boston, United States', 'Nashville, United States',
    'Los Angeles, United States', 'Seattle, United States',
    'London, United Kingdom', 'Manchester, United Kingdom', 'Berlin, Germany',
    'Munich, Germany', 'Paris, France', 'Sydney, Australia',
    'Auckland, New Zealand', 'Osaka, Japan'];
  var VISITOR_SUBS = ['New breaks added weekly', 'Fresh breaks drop every week',
    'Thanks for stopping by'];

  var card = document.getElementById('ChamaxPopCard');
  var img = document.getElementById('ChamaxPopImg');
  var icon = document.getElementById('ChamaxPopIcon');
  var chip = document.getElementById('ChamaxPopChip');
  var dot = document.getElementById('ChamaxPopDot');
  var bar = document.getElementById('ChamaxPopBar');
  var line1 = document.getElementById('ChamaxPopLine1');
  var line2 = document.getElementById('ChamaxPopLine2');
  var line3 = document.getElementById('ChamaxPopLine3');
  var closeBtn = document.getElementById('ChamaxPopClose');
  if (!card || !closeBtn) { return; }

  /* ---- Visitors-today count ---------------------------------------------
     Derived client-side from a seed of the Toronto calendar date, so every
     visitor sees the same plausible number on a given day: ~150-250 in the
     early morning, growing smoothly to ~650-950 by evening. Pure function
     of (date, time of day) — it cannot jump around between popups, and a
     per-session floor keeps it monotonic even across a reseed boundary.
     VISITOR-COUNT-BEGIN (kept pure for verification) */
  function chamaxSeedHash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h >>> 0;
  }
  function chamaxMulberry32(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) >>> 0;
      var t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function chamaxTorontoParts(now) {
    var parts = { y: now.getFullYear(), mo: now.getMonth() + 1, d: now.getDate(), h: now.getHours(), mi: now.getMinutes() };
    try {
      var fmt = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Toronto', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false
      });
      var got = {};
      fmt.formatToParts(now).forEach(function (p) { got[p.type] = p.value; });
      parts = {
        y: parseInt(got.year, 10), mo: parseInt(got.month, 10), d: parseInt(got.day, 10),
        h: parseInt(got.hour, 10) % 24, mi: parseInt(got.minute, 10)
      };
    } catch (e) {}
    return parts;
  }
  function chamaxVisitorCount(now) {
    var p = chamaxTorontoParts(now);
    var seedStr = 'chamax-visitors-' + p.y + '-' +
      ('0' + p.mo).slice(-2) + '-' + ('0' + p.d).slice(-2);
    var rng = chamaxMulberry32(chamaxSeedHash(seedStr));
    var dayStart = 140 + Math.floor(rng() * 70);   /* 140-209 at midnight */
    var dayTarget = 640 + Math.floor(rng() * 300); /* 640-939 by end of day */
    var frac = (p.h * 60 + p.mi) / 1439;
    var eased = Math.pow(frac, 1.35);
    return Math.round(dayStart + (dayTarget - dayStart) * eased);
  }
  /* VISITOR-COUNT-END */
  var visitorFloor = 0;

  var done = false;
  var visible = false;
  var tShow = null;
  var tHide = null;
  var tDetach = null;
  var lastProductIdx = -1;
  var shownAt = 0;
  var elapsedBeforePause = 0;
  var TEST_SEQ = ['purchase', 'cart', 'visitor'];
  var testStep = 0;

  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function rand(min, max) { return min + Math.floor(Math.random() * (max - min)); }

  function pickProduct() {
    if (pool.length === 1) { lastProductIdx = 0; return pool[0]; }
    var i = lastProductIdx;
    while (i === lastProductIdx) { i = Math.floor(Math.random() * pool.length); }
    lastProductIdx = i;
    return pool[i];
  }

  function pickType() {
    if (testMode && testStep < TEST_SEQ.length) { return TEST_SEQ[testStep++]; }
    if (Math.random() < 1 / 3) { return 'visitor'; }
    return Math.random() < 0.5 ? 'purchase' : 'cart';
  }

  function timeAgo() {
    var mins = rand(4, 175);
    return mins < 115 ? (mins + ' minutes ago')
      : (Math.max(2, Math.round(mins / 60)) + ' hours ago');
  }

  function composeProduct(type) {
    var p = pickProduct();
    var verb = type === 'cart' ? 'Added to Cart' : 'Purchased';
    var who = Math.random() < 0.35 ? 'Someone' : pick(NAMES);
    line1.textContent = who + ' in ' + pick(CITIES);
    line2.textContent = '';
    line2.appendChild(document.createTextNode(verb + ' ' + p.t));
    if (p.teams && p.teams.length && Math.random() < 0.55) {
      var team = pick(p.teams);
      if (team && !/^spot\b/i.test(team) && !/^default/i.test(team)) {
        line2.appendChild(document.createTextNode(' \u00B7 the '));
        var strong = document.createElement('strong');
        strong.textContent = team;
        line2.appendChild(strong);
        line2.appendChild(document.createTextNode(' spot'));
      }
    }
    line3.textContent = timeAgo();
    var m = /#([A-Za-z]{1,3}\d+[A-Za-z]?)/.exec(p.t || '');
    if (m) { chip.textContent = '#' + m[1].toUpperCase(); chip.hidden = false; }
    else { chip.hidden = true; }
    dot.hidden = true;
    card.setAttribute('href', p.u);
    if (p.img) { img.setAttribute('src', p.img); img.style.display = ''; }
    else { img.style.display = 'none'; }
    icon.hidden = true;
  }

  function composeVisitor() {
    var n = chamaxVisitorCount(new Date());
    if (n < visitorFloor) { n = visitorFloor; }
    visitorFloor = n;
    var num = n.toLocaleString ? n.toLocaleString('en-US') : String(n);
    var variant = rand(0, 3);
    line1.textContent = 'Live traffic';
    line2.textContent = variant === 0 ? (num + ' visitors today')
      : variant === 1 ? (num + ' people visited Chamax today')
      : (num + ' visitors so far today');
    line3.textContent = pick(VISITOR_SUBS);
    chip.hidden = true;
    dot.hidden = false;
    card.removeAttribute('href');
    img.style.display = 'none';
    icon.hidden = false;
  }

  function clearTimers() {
    if (tShow) { clearTimeout(tShow); tShow = null; }
    if (tHide) { clearTimeout(tHide); tHide = null; }
    if (tDetach) { clearTimeout(tDetach); tDetach = null; }
  }

  function startHideTimer(ms) {
    if (tHide) { clearTimeout(tHide); }
    tHide = setTimeout(hide, ms);
  }

  function show() {
    if (done) { return; }
    if (document.hidden) { schedule(2000); return; }
    var type = pickType();
    if (type === 'visitor') { composeVisitor(); } else { composeProduct(type); }
    root.hidden = false;
    void root.offsetWidth; /* force reflow so the transition + bar run */
    root.classList.remove('chamax-pop--paused');
    root.classList.add('chamax-pop--in');
    if (bar) {
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
      bar.style.animationDuration = VISIBLE_MS + 'ms';
    }
    visible = true;
    elapsedBeforePause = 0;
    shownAt = Date.now();
    startHideTimer(VISIBLE_MS);
  }

  function hide() {
    if (!visible) { return; }
    root.classList.remove('chamax-pop--in');
    root.classList.remove('chamax-pop--paused');
    visible = false;
    if (tDetach) { clearTimeout(tDetach); }
    tDetach = setTimeout(function () { root.hidden = true; }, 480);
    schedule(testMode ? TEST_GAP_MS : GAP_MS);
  }

  function schedule(delay) {
    if (done) { return; }
    if (tShow) { clearTimeout(tShow); }
    tShow = setTimeout(show, delay);
  }

  closeBtn.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    done = true;
    clearTimers();
    root.classList.remove('chamax-pop--in');
    root.hidden = true;
    visible = false;
    try { localStorage.setItem(OPTOUT_KEY, String(Date.now())); } catch (e) {}
  });

  /* Round 10.1: force same-tab navigation for clicks inside a purchase /
     added-to-cart card. Capture phase at the popup root, so the handler
     runs before any target/bubble-phase script can cancel the click, and
     it also catches clicks delivered to a child element of the anchor
     (a child .click() never triggers the anchor's own activation).
     Modifier/middle clicks are left to the anchor's default (new tab).
     The close button and the visitor card (no href) never navigate. */
  root.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('#ChamaxPopClose')) { return; }
    if (event.button !== undefined && event.button !== 0) { return; }
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { return; }
    var href = card.getAttribute('href');
    if (!href || href === '#') { return; }
    event.preventDefault();
    window.location.href = href;
  }, true);

  /* Hover pauses the display timer (and the progress bar with it). */
  root.addEventListener('mouseenter', function () {
    if (!visible || done) { return; }
    elapsedBeforePause += Date.now() - shownAt;
    if (tHide) { clearTimeout(tHide); tHide = null; }
    root.classList.add('chamax-pop--paused');
  });
  root.addEventListener('mouseleave', function () {
    if (!visible || done) { return; }
    root.classList.remove('chamax-pop--paused');
    shownAt = Date.now();
    var remaining = VISIBLE_MS - elapsedBeforePause;
    startHideTimer(remaining > 600 ? remaining : 600);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      clearTimers();
      if (visible) {
        root.classList.remove('chamax-pop--in');
        root.classList.remove('chamax-pop--paused');
        root.hidden = true;
        visible = false;
      }
    } else if (!done) {
      schedule(rand(1500, 3500));
    }
  });

  schedule(testMode ? 400 : FIRST_DELAY);
})();
